import React from 'react'

import PropTypes from 'prop-types'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

import GuestBox from './GuestBox'
import UserBox from './UserBox'

function SelectedUsers({
  users = EMPTY_ARRAY, emails = EMPTY_ARRAY, scope, removeUser = NOOP, removeGuest = NOOP,
}) {
  return (
    <div className="row">
      {users.map(user => (
        <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={user.id}>
          <UserBox attributes={user} removeUser={removeUser} scope={scope} boxClass="card card--interactive" />
        </div>
      ))}
      {emails.map(email => (
        <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={email}>
          <GuestBox email={email} removeGuest={removeGuest} boxClass="card card--interactive" />
        </div>
      ))}
    </div>
  )
}

SelectedUsers.propTypes = {
  users: PropTypes.array,
  emails: PropTypes.array,
  scope: PropTypes.string.isRequired,
  removeUser: PropTypes.func,
  removeGuest: PropTypes.func,
}

export default SelectedUsers
